import { iotDevicesTypes } from 'redux/reducers/iotDevices/iotDevicesTypes';
import { api_get, api_post, api_put } from 'services/api';
import { startRequestComp, stopRequestComp, setSnackbar } from '../search/searchActions';

const {
  GET_IOT_DEVICES,
  GET_IOT_DEVICE,
  CREATE_IOT_DEVICE,
  MOD_IOT_DEVICE,
  ADD_IOT_DEVICE_MODE,
  EDIT_IOT_DEVICE_MODE,
  RESET_IOT_DEVICE_SELECTED,
  GET_ASSIGN_HISTORY,
  GET_IOT_DEVICES_BY_ACCOUNT,
  CLEAR_ACCOUNT_IOT_DEVICES,
  SET_IOT_DEVICES_FILTERS,
} = iotDevicesTypes;

const BASE = `${process.env.REACT_APP_URL}/crm/iot-devices`;

export const getIotDevices = (idStation) => async (dispatch) => {
  dispatch(startRequestComp('loadingIotDevices'));
  try {
    const resp = await api_get(`${BASE}?idStation=${idStation}`);
    dispatch({ type: GET_IOT_DEVICES, payload: resp });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingIotDevices'));
};

export const getIotDeviceById = (id) => async (dispatch) => {
  dispatch(startRequestComp('loadingIotDevices'));
  try {
    const resp = await api_get(`${BASE}/${id}`);
    dispatch({ type: GET_IOT_DEVICE, payload: resp });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingIotDevices'));
};

export const getIotDevicesByAccount = (idAccount) => async (dispatch) => {
  dispatch(startRequestComp('loadingIotDevicesByAccount'));
  try {
    const resp = await api_get(`${BASE}/by-account/${idAccount}`);
    dispatch({ type: GET_IOT_DEVICES_BY_ACCOUNT, payload: resp });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingIotDevicesByAccount'));
};

export const createIotDevice = (form, onClose) => async (dispatch) => {
  dispatch(startRequestComp('loadingIotDevices'));
  try {
    const resp = await api_post(BASE, form);
    dispatch({ type: CREATE_IOT_DEVICE, payload: resp });
    dispatch(setSnackbar('Dispositivo creado con éxito', 'success'));
    onClose && onClose();
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingIotDevices'));
};

export const editIotDevice = (id, form, onClose) => async (dispatch) => {
  dispatch(startRequestComp('loadingIotDevices'));
  try {
    const resp = await api_put(`${BASE}/${id}`, form);
    dispatch({ type: MOD_IOT_DEVICE, payload: resp });
    dispatch(setSnackbar('Dispositivo actualizado', 'success'));
    onClose && onClose();
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingIotDevices'));
};

export const assignIotDevice = (id, form, onClose) => async (dispatch) => {
  dispatch(startRequestComp('loadingIotDevices'));
  try {
    const resp = await api_post(`${BASE}/${id}/assign`, form);
    dispatch({ type: MOD_IOT_DEVICE, payload: resp });
    dispatch(setSnackbar('Dispositivo vinculado con éxito', 'success'));
    onClose && onClose();
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingIotDevices'));
};

export const unassignIotDevice = (id, form, onClose) => async (dispatch) => {
  dispatch(startRequestComp('loadingIotDevices'));
  try {
    const resp = await api_post(`${BASE}/${id}/unassign`, form);
    dispatch({ type: MOD_IOT_DEVICE, payload: resp });
    dispatch(setSnackbar('Dispositivo desvinculado', 'success'));
    onClose && onClose();
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingIotDevices'));
};

export const getAssignHistory = (id) => async (dispatch) => {
  dispatch(startRequestComp('loadingIotDevices'));
  try {
    const resp = await api_get(`${BASE}/${id}/assign-history`);
    dispatch({ type: GET_ASSIGN_HISTORY, payload: resp });
  } catch (error) {
    dispatch(setSnackbar(error));
  }
  dispatch(stopRequestComp('loadingIotDevices'));
};

export const clearAccountIotDevices = () => ({ type: CLEAR_ACCOUNT_IOT_DEVICES });
export const addIotDeviceMode = () => ({ type: ADD_IOT_DEVICE_MODE });
export const editIotDeviceMode = () => ({ type: EDIT_IOT_DEVICE_MODE });
export const resetIotDeviceSelected = () => ({ type: RESET_IOT_DEVICE_SELECTED });
export const setIotDevicesFilters = (key = '', data) => ({
  type: SET_IOT_DEVICES_FILTERS,
  payload: { key, data },
});
